import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { LOCAL__ui_set_field_for_generation_layout } from '@/state/ui/image/LOCAL__ui_set_field_for_generation_layout';
import { ENUM__generation_status } from '@shared/dto/generation/_enums/ENUM__generation_status';
import { FIELD__token } from '@shared/dto/generation/graph_invoke/_fields/token/FIELD__token';
import { ENUM__page_generation_layout } from '../../_enums/ENUM__page_generation_layout';

export function WATCHER__generation_token_edit_reset() {
  const dispatch = use_dispatch();

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__layout, g_grid2d__token_edit, global__page_type } = use_slice_ui(['g_general__layout', 'g_grid2d__token_edit', 'global__page_type']);

  use_effect(() => {
    if (g_general__layout == ENUM__page_generation_layout.OUTPUTS) return; //no need to reset
    if (g_grid2d__token_edit.is_stub()) return; //no need to reset

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_grid2d__token_edit', field: FIELD__token.CREATE_STUB() }));
  }, [g_general__layout]);

  use_effect(() => {
    if (generation_current._id == g_grid2d__token_edit.meta.graph_id) return; //no need to reset
    if (g_grid2d__token_edit.is_stub()) return; //no need to reset

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_grid2d__token_edit', field: FIELD__token.CREATE_STUB() }));
  }, [global__page_type]);

  use_effect(() => {
    if (global__page_type.includes(ENUM__page_type.GENERATION_WITHOUT_PARAMS)) return; //no need to reset
    if (g_grid2d__token_edit.is_stub()) return; //no need to reset

    dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_grid2d__token_edit', field: FIELD__token.CREATE_STUB() }));
  }, [global__page_type]);

  use_effect(() => {
    if (generation_current.is_stub() || generation_current.status != ENUM__generation_status.ADJUSTING) {
      dispatch(LOCAL__ui_set_field_for_generation_layout({ key: 'g_grid2d__token_edit', field: FIELD__token.CREATE_STUB() }));
    }
  }, []);

  return null;
}
